import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CheckBoxData } from '../../../../shared/models';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent {
  @Input() data: CheckBoxData;

  @Input() wrapperId: string = '';
  @Input() checkboxId: string = '';

  @Input() isSmallFontSize: boolean;

  @Output() valueChanged = new EventEmitter<null>();
  @Output() lockedCheckboxClick = new EventEmitter<null>();

  onValueChanged(): void {
    this.data.checked = !this.data.checked;

    this.valueChanged.emit(null);
  }
}
